const TITLE_MAX = 100
const TITLE_MIN = 5
const DESC_MAX = 200
const DESC_MIN = 10

export const LOI_TITLE_PATTERN = /^[a-zA-Z0-9&\- ]+$/

export const LOI_EDIT_LIMITS = {
  TITLE_MAX,
  TITLE_MIN,
  DESC_MAX,
  DESC_MIN,
} as const

/** Inline validation message for title (empty string = valid for counter-only UI). */
export function loiTitleFieldError(title: string): string {
  const titleLen = title.length
  if (titleLen > 0 && titleLen < TITLE_MIN) {
    return `At least ${TITLE_MIN} characters`
  }
  if (titleLen > TITLE_MAX) {
    return `Max ${TITLE_MAX} characters`
  }
  if (titleLen > 0 && !LOI_TITLE_PATTERN.test(title)) {
    return 'Only letters, numbers, spaces, & and - allowed'
  }
  return ''
}

/** Inline validation message for description. */
export function loiDescriptionFieldError(description: string): string {
  const descLen = description.length
  if (descLen > 0 && descLen < DESC_MIN) {
    return `At least ${DESC_MIN} characters`
  }
  if (descLen > DESC_MAX) {
    return `Max ${DESC_MAX} characters`
  }
  if (/[\r\n]/.test(description)) {
    return 'No line breaks'
  }
  return ''
}
